/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Developer_No_ClientsInputs */



/**
* | output |
* | --- |
* | "No OAuth applications registered yet." |
*
* @param {Developer_No_ClientsInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const developer_no_clients = /** @type {((inputs?: Developer_No_ClientsInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Developer_No_ClientsInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucune application OAuth enregistrée pour le moment.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No hay aplicaciones OAuth registradas todavía.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Nenhum aplicativo OAuth registrado ainda.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessuna applicazione OAuth registrata ancora.")
	return /** @type {LocalizedString} */ ("No OAuth applications registered yet.")
});